import { NestedProjectExplorer } from '@tableau/nested-project-explorer';
import { ActivitySpinnerWidget } from '@tableau/widgets';
import * as React from 'react';

import { projectPickerFieldStyles, projectPickerStyles } from '~src/projects/components/styles/ProjectPickerStyles';

import { Messages } from '../../codegen/Localize';
import { classes, cssClass } from '../../style';
import { useProjects } from '../../uploadContent/utils/ProjectExplorerEffects';

export type LocationInputProps = {
  selectedProjectId: string;
  selectProject: (projectId: string) => void;
}

export const LocationInput = (props: LocationInputProps): JSX.Element => {
  const projectTree = useProjects();
  return <>
    <label>
      {Messages.lensCurationLocation()}
    </label>
    <div className={classes(projectPickerStyles, projectPickerFieldStyles)} style={{ height: 200 }}>
      {projectTree ?
        <NestedProjectExplorer
          topLevelDestinationStatus={'structurally_invalid'}
          projects={projectTree}
          onSelectedProjectChanged={project => props.selectProject(project?.id)}
          initiallySelectedProjectId={props.selectedProjectId}
          selectRowOnExpansion={false}
          keepParentsOfSelectedItemExpanded={false}
        /> :
        <div className={loadingSpinnerStyle}>
          <ActivitySpinnerWidget testId={'curation-dialog-location'} />
        </div>}
    </div>
  </>;
};

const cssPrefix = 'LensCurationLocationPicker';

const loadingSpinnerStyle = cssClass(cssPrefix, 'loadingSpinner', {
  display: 'flex',
  justifyContent: 'space-around',
});
